import styled from 'styled-components'

export const TileContainer = styled.div`
  padding: 5px;
`
